import React from 'react'
import clsx from 'clsx'
import { MarkdownBody } from '@/components/atoms/MarkdownBody/MarkdownBody'
import { RichTextField } from '@/components/organisms/RichTextField/RichTextField'
import { CaseStudyContentProps } from './types'
import * as style from './CaseStudyContent.module.css'

export function CaseStudyContent({ content }: CaseStudyContentProps) {
  return (
    <section className="max-w-screen-desktop mx-auto py-48 netbook:pb-64 font-sans">
      <div className={clsx('text-accent-navy-blue text-bodyL max-w-52 mx-auto', style.content)}>
        {typeof content === 'string' ? <MarkdownBody>{content}</MarkdownBody> : <RichTextField data={content} />}
      </div>
    </section>
  )
}
